import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Wspolpraca-online/client/OnlineTrainingClient.tsx");
